// Ruta: packages/api-client/src/endpoints/auth.api.ts

import { apiClient } from '../client.js'
import type { BFFResponse } from '../types/common.types.js'
import type {
  LoginRequest,
  LoginResponse,
  RefreshRequest,
  RefreshResponse,
  LogoutRequest,
} from '../types/auth.types.js'

export const authApi = {
  login: (body: LoginRequest): Promise<BFFResponse<LoginResponse>> =>
    apiClient.post('auth/login', { json: body }).json<BFFResponse<LoginResponse>>(),

  refresh: (body: RefreshRequest): Promise<BFFResponse<RefreshResponse>> =>
    apiClient.post('auth/refresh', { json: body }).json<BFFResponse<RefreshResponse>>(),

  logout: (body: LogoutRequest): Promise<void> =>
    apiClient.post('auth/logout', { json: body }).json<void>(),
}
